module.exports = __webpack_public_path__ + "img/heart_16.58ae8b75.png";